import {
  createFileRoute,
} from '@tanstack/react-router';

import Login from '#features/auth/session/Login';
import {
  sessionTokenValidator,
} from '#src/types/sessionToken';

export const Route = createFileRoute('/_app/auth/login')({
  component: RouteComponent,
  validateSearch: sessionTokenValidator,
});

function RouteComponent() {
  return (
    <Login />
  );
}
